module.exports = __webpack_public_path__ + "static/media/close-grey.c968612b.svg";